module.exports = __webpack_public_path__ + "static/img/introduceC1.ed48ef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceC1.png
// module id = KnaO
// module chunks = 0